import { render, staticRenderFns } from "./nav-sidebar.vue?vue&type=template&id=656dab25&scoped=true&"
import script from "./nav-sidebar.vue?vue&type=script&lang=js&"
export * from "./nav-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./nav-sidebar.vue?vue&type=style&index=0&id=656dab25&lang=scss&scoped=true&"
import style1 from "./nav-sidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656dab25",
  null
  
)

export default component.exports